import { ConfigTaskError } from './config.service';
import { HttpErrorResponse } from '@angular/common/http';

export enum ConfigApiErrorTypes {
  CreateConfigError,
  DeployConfigTaskCreationError,
  DeployConfigTaskPollingError,
  DeployPreviewConfigTaskCreationError,
  DeployPreviewConfigTaskPollingError,
  UndeployConfigTaskCreationError,
  UndeployConfigTaskPollingError,
  LoadConfigError,
  NoConfigForProject,
  ConfigConflictError,
}

export class ConfigApiError {
  constructor(public type: ConfigApiErrorTypes, public error: Error) {}
}

export const isTaskPollingError = (error: ConfigApiError): boolean =>
  [
    ConfigApiErrorTypes.DeployConfigTaskPollingError,
    ConfigApiErrorTypes.DeployPreviewConfigTaskPollingError,
    ConfigApiErrorTypes.UndeployConfigTaskPollingError,
  ].includes(error.type);

export const getConfigTaskError = (error: ConfigApiError): ConfigTaskError =>
  isTaskPollingError(error)
    ? (error.error as ConfigTaskError)
    : ((error.error as HttpErrorResponse).error.error as ConfigTaskError);
